export default __webpack_public_path__ + "static/media/forward_to_inbox.b3e84849.svg";